import languages from 'constants/languages';
import { SocietyCorporateId } from 'types/Society';

export const partnerDetailsByCorporateId = {
  [SocietyCorporateId.DEFAULT]: {
    showTotalShares: true,
    showTotalCoOwnerShares: false,
    showPercentageShares: true,
    showTotalInvested: true,
    showInvestedResult: true,
    showPartnerEditButton: true,
    showNationality: true,
    showSindication: true,
    showCivilStatus: true,
    showPartnerLanguage: true,
    showPartnerLanguageSelector: false,
    partnerLanguages: [],
    showSharingButton: true,
    showSendEmailButton: true,
    showIncorporationDate: true,
    showPoweredBy: true,
    isPartnerEmailOptional: false,
  },
  [SocietyCorporateId.AXA]: {
    showTotalShares: true,
    showTotalCoOwnerShares: true,
    showPercentageShares: true,
    showTotalInvested: false,
    showPartnerEditButton: false,
    showInvestedResult: false,
    showNationality: false,
    showSindication: false,
    showCivilStatus: false,
    showPartnerLanguage: false,
    showPartnerLanguageSelector: true,
    partnerLanguages: [languages.es, languages.cat],
    showSharingButton: false,
    showSendEmailButton: true,
    showIncorporationDate: false,
    showPoweredBy: false,
    isPartnerEmailOptional: true,
  },
};
